module.exports = __webpack_public_path__ + "static/media/heart.57912ef4.png";